export const getImageSrcset = (sizes, url, isTransparent = false) => {
    if (!url) {
        return '';
    }
    return sizes.map((size) => cloudinaryUrlWithSize(size, url, true, isTransparent)).join(',');
};
const cloudinaryUrlWithSize = (size, url, srcSet = false, isTransparent) => {
    const imageBackground = isTransparent ? '' : 'b_white';
    let imageLocation = 'telia-pim';
    ['http', 'https'].forEach((protocol) => {
        if (url.includes(`${protocol}://res.cloudinary.com/telia-pim/image/upload/`)) {
            url = url.replace(`${protocol}://res.cloudinary.com/telia-pim/image/upload/`, '');
        }
        else if (url.includes(`${protocol}://res.cloudinary.com/telia/image/upload/`)) {
            url = url.replace(`${protocol}://res.cloudinary.com/telia/image/upload/`, '');
            imageLocation = 'telia';
        }
        else if (url.includes(`${protocol}://res.cloudinary.com/telia-dev/image/upload/`)) {
            url = url.replace(`${protocol}://res.cloudinary.com/telia-dev/image/upload/`, '');
            imageLocation = 'telia-dev';
        }
        else if (url.includes(`${protocol}://res.cloudinary.com/telia-test/image/upload/`)) {
            url = url.replace(`${protocol}://res.cloudinary.com/telia-test/image/upload/`, '');
            imageLocation = 'telia-test';
        }
    });
    if (url.startsWith('/upload')) {
        url = url.substr('/upload'.length + 1);
    }
    return `https://res.cloudinary.com/${imageLocation}/image/upload/ar_1,c_pad,${imageBackground}/f_auto,fl_lossy,q_auto:best,w_${size}/${url}${srcSet ? ` ${size}w` : ''}`;
};
//# sourceMappingURL=ImageUtil.js.map